export enum EmployeeWageRuleLogic {
  Day = 0,
  Leg = 1
}

export const EmployeeWageRuleLogicMapping: Record<EmployeeWageRuleLogic, string> = {
  [EmployeeWageRuleLogic.Day]: 'Day',
  [EmployeeWageRuleLogic.Leg]: 'Leg'
};
